import qs from 'qs'
import fetch from '../utils/Fetch'
import config from '@/config/Config.vue'

//获取当前城市
export function getCity(data) {
    return fetch({
        url: config.WEB_GETCITY_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}

//获取已开通城市列表
export function getCityList(data) {
    return fetch({
        url: config.WEB_GETCITYLIST_API,
        method: 'POST',
        data: qs.stringify(data)
    })
}